import { Component, Input } from '@angular/core';
import { SerialNumber } from 'src/app/models/data/device';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { NumericInputDirective } from '../../../../directives/numeric-input.directive';

@Component({
	selector: 'app-add-device-detail',
	templateUrl: './add-device-detail.component.html',
	styleUrls: ['./add-device-detail.component.scss'],
	imports: [MatFormField, MatInput, FormsModule, NumericInputDirective],
})
export class AddDeviceDetailComponent {
	@Input() addDeviceDetailTitle = '';
	@Input() addDeviceDetailDescription = '';
	txtSerialNumber!: string;
	serialNumberList!: SerialNumber[];

	constructor() {}

	get isValid(): boolean {
		let valid = false;
		// Check to make sure there is at leat 1 serial number added
		// and exclude any empty lines.
		if (this.txtSerialNumber) {
			this.txtSerialNumber = this.txtSerialNumber.replace(/[^\d\n]/g, '');
			this.serialNumberList = this.txtSerialNumber
				.split('\n')
				.filter((serialNumber) => serialNumber.trim() !== '')
				.map((serialNumber, index) => ({
					serialNumber: serialNumber,
				}));

			if (this.serialNumberList?.length > 0) {
				valid = true;
			} else {
				valid = false;
			}
		}
		return valid;
	}

	clearInput(): void {
		this.txtSerialNumber = '';
		this.serialNumberList = [];
	}

	setTxtSerialNumber(txtSerialNumber: string) {
		this.txtSerialNumber = txtSerialNumber;
	}
}
